import React, { ChangeEvent, useId } from 'react';
import clsx from 'clsx';

import { FormItem, FormItemProps } from '@/stories/components/Form/FormItem/FormItem';
import { Icon, isIconName, type IconType } from '@/stories/atoms/Icon/Icon';
import styles from './input.module.css';

export type FieldProps = {
  value?: string,
  setValue?: (value: string) => void
  icon?: IconType,
  suffix?: IconType | string,
  variant?: 'secondary' | 'ideeri' | 'ideeri-secondary'
} & FormItemProps

export type InputProps = React.ComponentProps<'input'> & Omit<FieldProps, 'ref'>

export const Input = ({
  label,
  id,
  value = '',
  setValue,
  required,
  inline,
  helpText,
  errorText,
  hideLabel,
  hideOptionnal,
  icon,
  suffix,
  variant,
  className,
  ...props
}: InputProps) => {
  const generatedId = useId()
  const {style, ...inputProps} = props

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target
    if (setValue) setValue(value as string)
  }

  return (
    <FormItem className={className} id={id || generatedId} label={label} inline={inline} hideLabel={hideLabel} hideOptionnal={hideOptionnal} required={required} helpText={helpText} errorText={errorText} style={style}>
      <div className={clsx(styles.wrapper, icon && 'has-icon', suffix && 'has-suffix')}>
        {icon ? <Icon icon={icon} className={styles.icon}/> : null}
        <input
          type="text"
          id={id || generatedId}
          className={clsx(styles.input, variant && styles[variant])}
          value={value}
          onChange={handleChange}
          {...inputProps}/>
        {suffix ? isIconName(suffix) ? <Icon icon={suffix} className={styles.suffix}/> : <span className={styles.suffix}>{suffix}</span> : null}
      </div>
    </FormItem>
  )
};
